<template>
  <div id="returnTop">
    <div v-if="screenWidth >750">
      <div v-if="toTop >= 900">
        <div class="BackTop">
          <span class="icon iconfont iconwangyeshangla" @click="btnTop"></span>
        </div>
      </div> 
    </div> 

    <div v-if="screenWidth < 750">
      <!-- <div v-if="toTop >= 900"> -->
        <div class="BackTop">
          <div class="Icon">
            <span class="icon iconfont iconlianxifangshi" @click="btnContact"></span>
          </div>
          <div class="Icon">
            <span class="icon iconfont iconshoujishangla" @click="btnTop"></span>
          </div>
        </div>
      <!-- </div>  -->
    </div>   
  </div>
</template>

<script>

export default {
    data(){
      return{
          toTop:0,
          screenWidth: document.body.clientWidth,
      }
  },
  mounted(){
    window.addEventListener('scroll', this.scrollToTop)
    
  },
  methods:{
    scrollToTop() { 
　　    var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
　　    this.toTop = scrollTop 
    },
    btnTop(){
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      if(scrollTop != 0){
        window.pageYOffset = 0
        document.documentElement.scrollTop = 0
        document.body.scrollTop = 0
      }
    },
    btnContact(){
      window.location.href = 'tel://021-62966209'
      
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* @import '../../../static/css/Overall.css'; */

/*超大PC屏幕下的专用样式*/
@media screen and (min-width: 750px){
  .BackTop{
    position: fixed;
    right: 1vw;
    z-index: 1000;
    bottom: 1vh;
    display: flex;
    flex-direction: column;
  }
  .icon{
    color: #cdcdcd;
    font-size: 32pt;
  }
  .icon:active{
    color: #707070;
  }
}
/* 移动端特殊样式 */
@media screen and (max-width: 750px){
  .BackTop{
    position: fixed;
    right: 2vw;
    z-index: 1000;
    bottom: 24px;
    display: flex;
    flex-direction: column;
  }
  .Icon{
    /* background: #fff; */
    height: 5vh;
    width: 10vw;
    margin-top: 4vw !important;
    border-radius: 30vw;
    line-height: 5vh;
  }
  .icon{
    background: #fff;
    color: #757676;
    font-size: 10vw;
    border-radius: 20vw;
  }
  .icon:active{
    color: #707070;
  }
}



</style>



// WEBPACK FOOTER //
// src/components/publicComponent/ReturnTop.vue